export default {
    en: {
      id: 'exercise1',
      title: "Fill in the S,C,Q boxes on the right by following the process we just explained to work out the Question, plus the Situation and the Complication that would make the reader ask that Question. I will guide you along",
      tasks: [
        {
          endText: {
            text: '',
            delay: 0
          },
          number: {
            text: '',
            style: ''
          },
          title: {
            text: '',
            style: '',
          },
          pyramid: {
            text: '',
            style: ''
          },
          s: {
            text: '',
            style: ''
          },
          c: {
            text: '',
            style: ''
          },
          q: {
            text: '',
            style: ''
          },
          arrows: '',
          additionalInfoBox: {
            text: '',
            style: ''
          },
          isFirst: true,
          isLast: false,
          pyramidQuestion: false,
          showPyramid: false,
          isBlinkingEffect: true
        },
        {
          number: {
            text: '1',
            delay: 0
          },
          title: {
            text: 'State the subject',
            delay: 0
          },
          pyramid: {
            text: 'Product Managment',
            delay: 500
          },
          arrows: `
                <line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">
                    <animate
                        attributeName="x2"
                        from="0"
                        begin="DOMNodeInserted"
                        to="161"
                        dur="0.505s"
                        fill="freeze"
                    />
                    <animate
                        attributeName="y2"
                        from="20"
                        begin="DOMNodeInserted"
                        to="296"
                        dur="0.500s"
                        fill="freeze"
                    />
                </line>
                <path d="" stroke="#050E61" stroke-width="3" 
                style="fill: #050E61">
                    <animate
                        attributeName="d"
                        begin="DOMNodeInserted + 0.5s"
                        fill="freeze"
                        from="M 158 293 L 158 293 L 158 293"
                        to="M 161 280 L 159 293 L 145 293"
                        dur="0.5s" />
                </path>`,
          additionalInfoBox: {
            text: '',
          },
          s: {
            delay: 0
          },
          c: {
            delay: 0
          },
          q: {
            delay: 0
          },
          isFirst: false,
          isLast: false,
          pyramidQuestion: false,
          showPyramid: false,
          isBlinkingEffect: true
        },
        {
          number: {
            text: '2',
            delay: 0
          },
          title: {
            text: 'Decide the question',
            delay: 0
          },
          pyramid: {
            text: 'Product Managment',
            delay: 0
          },
          arrows: `<line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">
                    <animate
                        attributeName="x2"
                        from="0"
                        begin="DOMNodeInserted"
                        to="412"
                        dur="0.5s"
                        fill="freeze"
                    />
                    <animate
                        attributeName="y2"
                        from="20"
                        begin="DOMNodeInserted"
                        to="250"
                        dur="0.5s"
                        fill="freeze"
                    />
                </line>
                <path d="" stroke="#050E61" stroke-width="3" 
                style="fill: #050E61">
                    <animate
                        attributeName="d"
                        begin="DOMNodeInserted + 0.5s"
                        fill="freeze"
                        from="M 384 236 L 384 236 L 384 236"
                        to="M 383 223 L 384 236 L 376 241"
                        dur="0.5s" />
                </path>`,
          additionalInfoBox: {
            text: '',
          },
          s: {
            delay: 0
          },
          c: {
            delay: 0
          },
          q: {
            text: 'How fix',
            delay: 500
          },
          isFirst: false,
          isLast: false,
          pyramidQuestion: false,
          showPyramid: false,
          isBlinkingEffect: true
        },
        {
          number: {
            text: '3',
            delay: 0
          },
          title: {
            text: 'State the rough answer (if you know it)',
            delay: 0
          },
          pyramid: {
            text: 'Fix Product Managment like this',
            delay: 500
          },
          arrows: `
                <line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">
                    <animate
                        attributeName="x2"
                        from="0"
                        begin="DOMNodeInserted"
                        to="161"
                        dur="0.505s"
                        fill="freeze"
                    />
                    <animate
                        attributeName="y2"
                        from="20"
                        begin="DOMNodeInserted"
                        to="296"
                        dur="0.500s"
                        fill="freeze"
                    />
                </line>
                <path d="" stroke="#050E61" stroke-width="3" 
                style="fill: #050E61">
                    <animate
                        attributeName="d"
                        begin="DOMNodeInserted + 0.5s"
                        fill="freeze"
                        from="M 158 293 L 158 293 L 158 293"
                        to="M 161 280 L 159 293 L 145 293"
                        dur="0.5s" />
                </path>`,
          additionalInfoBox: {
            text: '',
          },
          s: {
            delay: 0
          },
          c: {
            delay: 0
          },
          q: {
            text: 'How fix',
            delay: 0
          },
          isFirst: false,
          isLast: false,
          pyramidQuestion: false,
          showPyramid: false,
          isBlinkingEffect: true
        },
        {
          number: {
            text: '4',
            delay: 0
          },
          title: {
            text: 'Make a statement about the subject that the reader will agree with you is true. (Note: Always begin any introduction by making a statement about the subject)',
            delay: 0
          },
          pyramid: {
            text: 'Fix Product Managment like this',
            delay: 0
          },
          arrows: `
                <line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">
                    <animate
                        attributeName="x2"
                        from="0"
                        begin="DOMNodeInserted"
                        to="394"
                        dur="0.505s"
                        fill="freeze"
                    />
                    <animate
                        attributeName="y2"
                        from="20"
                        begin="DOMNodeInserted"
                        to="65"
                        dur="0.500s"
                        fill="freeze"
                    />
                </line>
                <path d="" stroke="#050E61" stroke-width="3" 
                style="fill: #050E61">
                    <animate
                        attributeName="d"
                        begin="DOMNodeInserted + 0.5s"
                        fill="freeze"
                        from="M 384 65 L 384 64 L 384 65"
                        to="M 379 56 L 384 64 L 377 71"
                        dur="0.5s" />
                </path>
                
                <line x1="0" y1="186" x2="0" y2="186" stroke="#050E61" stroke-width="3">
                    <animate
                        attributeName="x2"
                        from="0"
                        begin="DOMNodeInserted + 1s"
                        to="394"
                        dur="0.505s"
                        fill="freeze"
                    />
                    <animate
                        attributeName="y2"
                        from="186"
                        begin="DOMNodeInserted + 1s"
                        to="117"
                        dur="0.500s"
                        fill="freeze"
                    />
                </line>
                <path d="" stroke="#050E61" stroke-width="3" 
                style="fill: #050E61">
                    <animate
                        attributeName="d"
                        begin="DOMNodeInserted + 1.5s"
                        fill="freeze"
                        from="M 384 117 L 384 117 L 384 117"
                        to="M 378 110 L 384 117 L 380 128"
                        dur="0.5s" />
                </path>`,
          additionalInfoBox: {
            text: 'Imagine the reader says “Yes, I know that, so what?” That should lead you to the Complication',
            delay: 0
          },
          s: {
            text: 'PM used to market individual products in large orgs.',
            delay: 500
          },
          c: {
            delay: 0
          },
          q: {
            text: 'How fix',
            delay: 0
          },
          isFirst: false,
          isLast: false,
          pyramidQuestion: false,
          showPyramid: false,
          isBlinkingEffect: true
        },
        {
          number: {
            text: '5',
            delay: 0
          },
          title: {
            text: 'Word the Complication so that it triggers the question',
            delay: 0
          },
          pyramid: {
            text: 'Fix Product Managment like this',
            delay: 0
          },
          arrows: `
                <line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">
                    <animate
                        attributeName="x2"
                        from="0"
                        begin="DOMNodeInserted"
                        to="394"
                        dur="0.505s"
                        fill="freeze"
                    />
                    <animate
                        attributeName="y2"
                        from="20"
                        begin="DOMNodeInserted"
                        to="156"
                        dur="0.500s"
                        fill="freeze"
                    />
                </line>
                <path d="" stroke="#050E61" stroke-width="3" 
                style="fill: #050E61">
                    <animate
                        attributeName="d"
                        begin="DOMNodeInserted + 0.5s"
                        fill="freeze"
                        from="M 384 154 L 384 154 L 384 154"
                        to="M 382 142 L 384 154 L 376 159"
                        dur="0.5s" />
                </path>`,
          additionalInfoBox: {
            text: '',
          },
          s: {
            text: 'PM used to market individual products in large orgs.',
            delay: 0
          },
          c: {
            text: 'Not working, bad product',
            delay: 500
          },
          q: {
            text: 'How fix',
            delay: 0
          },
          isFirst: false,
          isLast: false,
          pyramidQuestion: false,
          showPyramid: false,
          showAditionalBox: false,
          isBlinkingEffect: true
        },
        {
          number: {
            text: '6',
            delay: 0
          },
          title: {
            text: 'State the Question',
            delay: 0
          },
          pyramid: {
            text: 'Fix Product Managment like this',
            delay: 0
          },
          arrows: `<line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">
                    <animate
                        attributeName="x2"
                        from="0"
                        begin="DOMNodeInserted"
                        to="412"
                        dur="0.5s"
                        fill="freeze"
                    />
                    <animate
                        attributeName="y2"
                        from="20"
                        begin="DOMNodeInserted"
                        to="250"
                        dur="0.5s"
                        fill="freeze"
                    />
                </line>
                <path d="" stroke="#050E61" stroke-width="3" 
                style="fill: #050E61">
                    <animate
                        attributeName="d"
                        begin="DOMNodeInserted + 0.5s"
                        fill="freeze"
                        from="M 384 236 L 384 236 L 384 236"
                        to="M 383 223 L 384 236 L 376 241"
                        dur="0.5s" />
                </path>`,
          additionalInfoBox: {
            text: '',
          },
          s: {
            text: 'PM used to market individual products in large orgs.',
            delay: 0
          },
          c: {
            text: 'Not working, bad product',
            delay: 0
          },
          q: {
            text: 'Is it bad?',
            delay: 500
          },
          isFirst: false,
          isLast: false,
          pyramidQuestion: false,
          showPyramid: false,
          showAditionalBox: true,
          isBlinkingEffect: true
        },
        {
          endText: {
            text: '',
            delay: 0
          },
          number: {
            text: '7',
            delay: 0
          },
          title: {
            text: 'State the Answer',
            delay: 0
          },
          pyramid: {
            text: 'No, it is a sound concept, just misapplied',
            delay: 500
          },
          arrows: `
                <line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">
                    <animate
                        attributeName="x2"
                        from="0"
                        begin="DOMNodeInserted"
                        to="161"
                        dur="0.505s"
                        fill="freeze"
                    />
                    <animate
                        attributeName="y2"
                        from="20"
                        begin="DOMNodeInserted"
                        to="296"
                        dur="0.500s"
                        fill="freeze"
                    />
                </line>
                <path d="" stroke="#050E61" stroke-width="3" 
                style="fill: #050E61">
                    <animate
                        attributeName="d"
                        begin="DOMNodeInserted + 0.5s"
                        fill="freeze"
                        from="M 158 293 L 158 293 L 158 293"
                        to="M 161 280 L 159 293 L 145 293"
                        dur="0.5s" />
                </path>`,
          additionalInfoBox: {
            text: '',
          },
          s: {
            text: 'PM used to market individual products in large orgs.',
            delay: 0
          },
          c: {
            text: 'Not working, bad product',
            delay: 0
          },
          q: {
            text: 'Is it bad?',
            delay: 0
          },
          hideInfoBox: false,
          isFirst: false,
          isLast: false,
          pyramidQuestion: false,
          showPyramid: false,
          showAditionalBox: true,
          rightArrows: `
          `,
          isBlinkingEffect: true
        },
        {
          endText: {
            text: 'Now go try it for yourself in the two exercises that follow',
            delay: 5700
          },
          number: {
            text: '8',
            delay: 0
          },
          title: {
            text: 'The Answer will trigger a new Question.',
            delay: 0
          },
          pyramid: {
            text: 'Successful Product Management reflects a continuing focus on strategy',
            delay: 0
          },
          arrows: ``,
          additionalInfoBox: {
            text: '',
          },
          s: {
            text: 'Product Managers have for years enabled large orgs to steer individual products to profitability',
            delay: 0
          },
          c: {
            text: 'Lately, hearing PM no longer relevant, no longer working well',
            delay: 0
          },
          q: {
            text: 'How fix?',
            delay: 0
          },
          hideInfoBox: true,
          isFirst: false,
          isLast: true,
          pyramidQuestion: true,
          showAditionalBox: true,
          showPyramid: true,
          pyramidDelay: 1700,
          rightArrows: `
            <line x1="160" y1="19" x2="160" y2="19" stroke="#050E61" stroke-width="3">
              <animate
                attributeName="y2"
                from="19"
                begin="DOMNodeInserted + 1s"
                to="340"
                dur="0.500s"
                fill="freeze"
              />
            </line>

            <path d="" stroke="#050E61" stroke-width="3">
              <animate
                attributeName="d"
                begin="DOMNodeInserted + 1.5s"
                fill="freeze"
                from="M 160 339 L 160 339 L 160 339"
                to="M 168 330 L 160 339 L 152 330"
                dur="0.5s" />
            </path>`,
          isBlinkingEffect: true
        }
      ],
      sTitle: "S = ",
      cTitle: "C = ",
      qTitle: "Q = ",
      additionalBoxText: {
        s: 'Do X to achieve Y',
        c: 'Not working because of Z',
        q: 'Is Z true?'
      },
      pyramidQuestionText: ' How?',
      connectors: `
                <svg width="924px" height="70px">

                    <line x1="465" y1="0" x2="465" y2="0" stroke="#fff" stroke-width="3">
                        <animate
                            attributeName="x2"
                            from="465"
                            begin="1s"
                            to="105"
                            dur="1s"
                            fill="freeze"
                        />
                        <animate
                            attributeName="y2"
                            from="0"
                            begin="1s"
                            to="70"
                            dur="1s"
                            fill="freeze"
                        />
                    </line>


                    <line x1="465" y1="0" x2="465" y2="0" stroke="#fff" stroke-width="3">
                        <animate
                            attributeName="x2"
                            from="465"
                            begin="1.5s"
                            to="340"
                            dur="1s"
                            fill="freeze"
                        />
                        <animate
                            attributeName="y2"
                            from="0"
                            begin="1.5s"
                            to="70"
                            dur="1s"
                            fill="freeze"
                        />
                    </line>


                    <line x1="465" y1="0" x2="465" y2="0" stroke="#fff" stroke-width="3">
                        <animate
                            attributeName="x2"
                            from="465"
                            begin="2s"
                            to="580"
                            dur="1s"
                            fill="freeze"
                        />
                        <animate
                            attributeName="y2"
                            from="0"
                            begin="2s"
                            to="70"
                            dur="1s"
                            fill="freeze"
                        />
                    </line>


                    <line x1="465" y1="0" x2="465" y2="0" stroke="#fff" stroke-width="3">
                        <animate
                            attributeName="x2"
                            from="465"
                            begin="2.5s"
                            to="820"
                            dur="1s"
                            fill="freeze"
                        />
                        <animate
                            attributeName="y2"
                            from="0"
                            begin="2.5s"
                            to="70"
                            dur="1s"
                            fill="freeze"
                        />
                    </line>
                </svg>`,
      pyramidBlocks: `
                <div class="pyramid-box pyramid-body"
                     ng-class="{'show-pyramid-body': vm.showPyramid}">
                    <p class="text" style="opacity: 1">Assign clear accountability for strategy</p>
                </div>
                <div class="pyramid-box pyramid-body"
                     ng-class="{'show-pyramid-body': vm.showPyramid}">
                    <p class="text" style="opacity: 1">Gather evidence for stated direction</p>
                </div>
                <div class="pyramid-box pyramid-body"
                     ng-class="{'show-pyramid-body': vm.showPyramid}">
                    <p class="text" style="opacity: 1">Involve management in crafting the final strategy</p>
                </div>
                <div class="pyramid-box pyramid-body"
                     ng-class="{'show-pyramid-body': vm.showPyramid}">
                    <p class="text" style="opacity: 1">Present a clear roadmap for achieving it</p>
                </div>
      `
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4b1/findingReadersQuestion/i18n/payoffFromProductManagement.js